// client/src/components/portal/SuggestInput.js — a text input with a small
// suggestion dropdown, for the portal Add Names grid. Typing is always
// allowed (a suggestion is only a shortcut); arrow keys move through the
// list, Enter or a click picks, Escape closes. Enter with nothing
// highlighted is passed to onEnter (the grid moves to the next row).
import { useState, useRef, useEffect } from 'react'

export default function SuggestInput({ value, onChange, suggest, onPick, onEnter, onPaste, inputProps = {} }) {
  const [open, setOpen] = useState(false)
  const [hi, setHi] = useState(-1)
  const wrap = useRef(null)
  const items = open && value.trim().length >= 2 ? suggest(value).slice(0, 8) : []

  useEffect(() => {
    if (!open) return
    function away(e) { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', away)
    return () => document.removeEventListener('mousedown', away)
  }, [open])

  function pick(item) {
    onPick(item)
    setOpen(false)
    setHi(-1)
  }

  function onKeyDown(e) {
    if (e.key === 'ArrowDown' && items.length) { e.preventDefault(); setHi(h => Math.min(h + 1, items.length - 1)) }
    else if (e.key === 'ArrowUp' && items.length) { e.preventDefault(); setHi(h => Math.max(h - 1, -1)) }
    else if (e.key === 'Escape') { setOpen(false); setHi(-1) }
    else if (e.key === 'Enter') {
      e.preventDefault()
      if (hi >= 0 && items[hi]) pick(items[hi])
      else { setOpen(false); onEnter?.() }
    }
  }

  return (
    <div ref={wrap} style={{ position: 'relative' }}>
      <input
        {...inputProps}
        value={value}
        autoComplete="off"
        onChange={e => { onChange(e.target.value); setOpen(true); setHi(-1) }}
        onFocus={() => setOpen(true)}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
      />
      {items.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, marginTop: 4, zIndex: 30,
          minWidth: '100%', width: 300, maxHeight: 280, overflowY: 'auto',
          background: 'var(--surface-raised)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)', boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        }}>
          <div style={{ padding: '6px 12px 4px', fontSize: 11, color: 'var(--text-muted)' }}>From your contacts</div>
          {items.map((it, i) => (
            <div
              key={it.key}
              onMouseDown={e => { e.preventDefault(); pick(it) }}
              onMouseEnter={() => setHi(i)}
              style={{
                padding: '7px 12px', cursor: 'pointer', fontSize: 13,
                background: i === hi ? 'var(--surface-hover)' : 'transparent',
              }}
            >
              <div style={{ color: 'var(--text-primary)' }}>{it.label}</div>
              {it.sub && <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', marginTop: 1 }}>{it.sub}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
